import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, imageUrl } from "@/lib/api";
import { sanitizeHtml } from "@/lib/sanitize";

export default function NewsArticlePage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/news/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-20 text-center">
        <h1 className="font-display text-4xl font-bold">Article not found</h1>
        <Link to="/news" className="text-primary underline mt-4 inline-block">Back to news</Link>
      </div>
    );
  }
  if (!article) return <div className="max-w-3xl mx-auto px-6 py-20">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 py-20" data-testid="news-article-page">
      <Link to="/news" className="text-sm text-muted-foreground hover:text-foreground">← All news</Link>
      <div className="mt-6 text-[11px] uppercase tracking-[0.25em] text-primary">
        {article.is_featured ? "Featured" : "News"} · {new Date(article.published_at).toLocaleDateString()}
      </div>
      <h1 className="font-display text-4xl md:text-6xl font-extrabold tracking-tighter mt-3">{article.title}</h1>
      {article.image_path && (
        <img src={imageUrl(article.image_path)} alt="" className="w-full mt-10 border border-border" />
      )}
      <div className="prose-woc mt-10" dangerouslySetInnerHTML={{ __html: sanitizeHtml(article.content_html) }} />
    </article>
  );
}
